import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  CardMedia,
  Input,
  TextField,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
} from "@mui/material";
import { useState, ChangeEvent, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showError } from "../../constants/toasts";
import { showToast } from "../../constants/toasts";
import {
  useCreateSubAdminMutation,
  useLazyGetRolesQuery,
  useLazySubAdminByIdQuery,
  useUpdateSubAdminMutation,
} from "../../service/subAdmin";
import PhoneInput from "react-phone-input-2";
import { Role, SubAdmin } from "../../types/General";

const AddSubadmin = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [addSubAdmin] = useCreateSubAdminMutation();
  const [getRoles] = useLazyGetRolesQuery();
  const [getSubAdminById] = useLazySubAdminByIdQuery();
  const [updateSubAdmin] = useUpdateSubAdminMutation();

  const [image, setImage] = useState<any>("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [roles, setRoles] = useState<Role[]>([]);
  const [subAdminData, setSubAdminData] = useState<SubAdmin | null>(null);

  const goBack = () => {
    navigate(-1);
  };

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("PhoneNumber", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("DialCountryCode", country?.dialCode);
  };

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;

    formik.setFieldValue("RoleId", value);
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setImage("");
      return;
    }

    const MAX_SIZE = 2 * 1024 * 1024; // 2MB

    if (file.size > MAX_SIZE) {
      showError("Image size must be less than 2MB.");
      event.target.value = "";
      return;
    }

    setImage(file);
    setUrl(URL.createObjectURL(file));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: subAdminData?.name || "",
      Email: subAdminData?.email || "",
      DialCountryCode: String(subAdminData?.countryDialCode) || "+971",
      PhoneNumber: subAdminData?.phoneNumber || "",
      RoleId: subAdminData?.roles?.id || "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required().required("Name is required"),
      Email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address"
        ),
      PhoneNumber: Yup.string()
        .required("Phone Number is required")
        .min(6, "Minimum 6 digits are required")
        .max(16, "Maximum 16 digits are required"),
      RoleId: Yup.string().required().required("RoleId is required"),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      // if (!image) {
      //   showError("Please upload image");
      //   return;
      // }

      const formData = new FormData();

      formData.append("Name", values.Name);
      formData.append("Email", values.Email);
      formData.append("DialCountryCode", values.DialCountryCode);
      formData.append("PhoneNumber", values.PhoneNumber);
      formData.append("RoleId", values.RoleId);
      formData.append("Image", image);
      if (id) {
        formData.append("id", id);
      }

      if (id) {
        try {
          setLoading(true);
          const response = await updateSubAdmin(formData).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            goBack();
            showToast(response?.message || "");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.error(error);
        }
      } else {
        try {
          setLoading(true);
          const response = await addSubAdmin(formData).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            goBack();
            showToast(response?.message || "");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.error(error);
        }
      }
    },
  });

  const getRolesApi = async () => {
    setLoading(true);
    try {
      const response = await getRoles({
        search: "",
        page: 1,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        const activeRoles =
          response?.data?.roles?.filter(
            (role: any) => role?.isActive === true
          ) || [];

        setRoles(activeRoles || []);
      } else {
        setRoles([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getSubAdminByIdApi = async () => {
    try {
      setLoading(true);
      const response = await getSubAdminById({ id }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setSubAdminData(response?.data || "");
        setImage(response?.data?.profileImage || "");
        setUrl(response?.data?.profileImage || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getRolesApi();
    if (id) {
      getSubAdminByIdApi();
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1 className="back_arrow">
          {" "}
          <IconButton onClick={() => goBack()}>
            {" "}
            <ArrowBackIcon />{" "}
          </IconButton>
          Add Sub-Admin
        </h1>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Upload Image</label>
              {url ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={url} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setUrl("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(e: any) => {
                      handleImageUpload(e);
                      e.target.value = null;
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_33">
              <label htmlFor="Name">Name</label>
              <TextField
                id="Name"
                name="Name"
                className="text_field"
                inputProps={{ maxLength: 40 }}
                value={formik.values.Name}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.Name && typeof formik.errors.Name === "string"
                    ? formik.errors.Name
                    : ""
                }
                placeholder="Enter Name"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="Email">Email Id</label>
              <TextField
                id="Email"
                name="Email"
                className="text_field"
                inputProps={{ maxLength: 40 }}
                value={formik.values.Email}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.Email &&
                  typeof formik.errors.Email === "string"
                    ? formik.errors.Email
                    : ""
                }
                placeholder="Enter Email Id"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label>Phone Number*</label>
              <PhoneInput
                enableSearch
                value={
                  formik.values.DialCountryCode + formik.values.PhoneNumber
                }
                country={"uae"}
                inputClass="phoneInput"
                onChange={(phone, country) => handleChangePhone(phone, country)}
                inputStyle={{ width: "100%", backgroundColor: "#232323" }}
                buttonClass="phoneBtn"
                placeholder="Phone Number"
              />
              <p className="err_msg">
                {error && !formik.values.PhoneNumber?.length
                  ? "Phone number is required"
                  : ""}
              </p>
            </div>
            <div className="control_group w_33">
              <label>Role</label>
              <Select
                fullWidth
                className="dropse"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                inputProps={{
                  "aria-label": "Without label",
                }}
                displayEmpty
                value={formik.values.RoleId}
                name="RoleId"
                onChange={handleChange1}
              >
                <MenuItem disabled value="">
                  Select Role
                </MenuItem>
                {roles?.map((role) => (
                  <MenuItem key={role?.roleId} value={role?.roleId}>
                    {role?.roleName}
                  </MenuItem>
                ))}
              </Select>
              {error && formik.values.RoleId == "" ? (
                <h6 className="err_msg">Role is required</h6>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setError(true);
                formik.submitForm();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default AddSubadmin;
